import styles from './A_ContentLink.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import cn from 'classnames';

interface A_ContentLinkProps {
  link: string;
}

const handleOpenLink = (link: string) => {
  window.open(link, '_blank', 'noopener,noreferrer');
};

const handleCopyLink = (link: string) => {
  navigator.clipboard.writeText(link);
};

export default function A_ContentLink({ link }: A_ContentLinkProps) {
  return (
    <div className={styles.wrapper}>
      <button
        className={styles.copy_button}
        onClick={() => handleCopyLink(link)}
      >
        <Q_Icon.LinkIcon width={24} height={24} fill='none' />
      </button>
      <a
        className={cn(styles.link, 'text-p-9')}
        href={link}
        onClick={() => handleOpenLink(link)}
      >
        {link}
      </a>
    </div>
  );
}
